'use client'
import clsx from 'clsx'

import styles from './SkipNavigation.module.scss'

// for accessibility the first focusable element in dom should be button to skip navigation and go to main content
const SkipNavigation = () => {
  return (
    <a
      href='#main'
      tabIndex={0}
      aria-label='Pomiń nawigację i przejdź do treści'
      className={clsx(styles.skipNavigation, 'visually-hidden')}
    >
      Pomiń nawigację
    </a>
  )
}

export default SkipNavigation
